export default {
  methods: {
    getPreSignedURL(file) {
      if (file) {
        if (file.opmode === 'url') {
          return Promise.resolve(file.url || file.cardBackgroundUrl)
        }
        if (file.opmode === 'filestore' && file.fileStore.filepath) {
          let filestorename = null
          if (this.filestore) {
            if (typeof this.filestore === 'string') {
              filestorename = this.filestore
            }
            else {
              filestorename = this.filestore.name
            }
          }
          if (filestorename) {
            return this.$store.dispatch('filestore/getFileURL', {
              filepath: file.fileStore.filepath,
              filestorename: filestorename,
              preset: file.fileStore.preset
            })
          }
        }
      }
      return Promise.resolve('')
    }
  }
}
